'use client'

import { type FC } from 'react'

import {
  LoginRegistrationUserLoginContent,
  LoginRegistrationUserLoginStateProvider,
  useGetRedirectToTargetPageAfterLogin,
} from '../../../login-registration'
import { type StoryblokComponentProps } from '../../model'
import { type StoryblokRedPointsLoginType } from '../../storyblok'
import { StoryblokComponentsRenderer } from '../StoryblokComponentsRenderer'

export const StoryblokRedPointsLogin: FC<
  StoryblokComponentProps<StoryblokRedPointsLoginType>
> = ({ blok: { content = [] } }) => {
  const redirectToTargetPage = useGetRedirectToTargetPageAfterLogin()

  return (
    <div className="my-2 bg-light-brand-medium shadow-m tablet:w-3/5 tablet:rounded-2xl">
      <LoginRegistrationUserLoginStateProvider>
        <div className="flex-1 basis-1/2 p-5 tablet:mb-6 tablet:ml-6 tablet:mr-3 tablet:rounded-2xl tablet:px-5">
          <LoginRegistrationUserLoginContent
            afterLoggedIn={redirectToTargetPage}
          />
        </div>
      </LoginRegistrationUserLoginStateProvider>
      <StoryblokComponentsRenderer bloks={content} />
    </div>
  )
}
